"use client";
import SearchBar from "@/components/shared/searchBar";
import { useRouter } from "next/navigation";
import React from "react";
import useChatgptHook from "@/hooks/useChatgptHook";
import { useSession } from "next-auth/react";

export const HomeSearch = ({ showLabel = true }: { showLabel?: boolean }) => {
  const router = useRouter();
  const { chatGPTPromptForSearch } = useChatgptHook();
  const { data: session } = useSession();
  const placeholders = [
    "freelance interpreter from German to English for legal documents",
    "subtitling jobs in French",
    "voiceover services in Italian",
    "MT post editing Spanish",
    "certified translator for immigration documents",
    "companies offering localization",
    "I’m looking for Nicolás Calcagno",
    "forums in Portuguese",
    "how to become a professional member",
    "remote interpreting opportunities",
    "language assessment for French",
    "latest translation tech news",
    "edit account settings",
    "how to update my billing address",
    "change my display name",
    "training for medical translation",
    "courses on transcreation",
    "online workshop for court interpreting",
    "I want to know how ProZ.com works",
    "where can I contact support",
    "how does ProZPay work",
    "I want to work as a translator",
    "find Spanish to Chinese freelancers",
    "search for interpreters in Buenos Aires",
    "best online subtitling courses",
    "profile of Laura Martinez",
    "certified translation agencies",
    "look up news on AI in translation",
  ];
  const handleInputChange = async (value: string) => {
    if (!value) return;

    const query = new URLSearchParams();
    query.append("prompt", chatGPTPromptForSearch(value));
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/chatgpt?${query.toString()}`;

    try {
      const response = await fetch(url);
      const jsonToFilterBy = await response.json();
      const content = JSON.parse(jsonToFilterBy.content || "{}");
      const searchingFor = content?.searching_for || "";

      const redirectUrl = new URLSearchParams();
      redirectUrl.append("search", value);
      redirectUrl.append("content", content);

      switch (searchingFor) {
        case "freelancers":
        case "services":
          router.push(`/providers?${redirectUrl.toString()}`);
          break;
        case "jobs":
        case "opportunities":
          router.push(`/opportunities?${redirectUrl.toString()}`);
          break;
        case "businesses":
          router.push(`/business?${redirectUrl.toString()}`);
          break;
        case "users":
          router.push(`/providers?${redirectUrl.toString()}`);
          break;
        case "forums":
          window.open(`https://www.proz.com/forum?${redirectUrl.toString()}`, "_blank");
          break;
        case "memberships":
          router.push(`/membership?${redirectUrl.toString()}`);
          break;
        case "language_assessment":
          router.push(`/language-assessment?${redirectUrl.toString()}`);
          break;
        case "news":
          router.push(`/news?${redirectUrl.toString()}`);
          break;
        case "profile":
          router.push(`/profile/${session?.user?.entity_id}?${redirectUrl.toString()}`);
          break;
        case "learn":
          router.push(`/learn`);
          break;
        case "site_info":
          router.push(`/about/overhaul?${redirectUrl.toString()}`);
          break;
        case "support":
          router.push(`/support-center?${redirectUrl.toString()}`);
          break;
        case "prozpay":
          window.open(`https://www.proz.com/pay/about?${redirectUrl.toString()}`, "_blank");
          break;
        case "probono":
          router.push(`/community/proz-pro-bono?${redirectUrl.toString()}`);
          break;
        case "pastey":
          router.push(`/pastey?${redirectUrl.toString()}`);
          break;
        case "cafetran":
          router.push(`/cafetran?${redirectUrl.toString()}`);
          break;
        case "interpreters-community":
          router.push(`/community/interpreters?${redirectUrl.toString()}`);
          break;
        case "wit-community":
          router.push(`/community/women-in-translation?${redirectUrl.toString()}`);
          break;
        case "managed-services":
          router.push(`/managed-services?${redirectUrl.toString()}`);
          break;
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  const randomPlaceholder = React.useMemo(
    () => placeholders[Math.floor(Math.random() * placeholders.length)],
    []
  );

  return (
    <SearchBar
      label={showLabel ? "Proudly brought to you with AI" : ""}
      onInputChange={handleInputChange}
      placeholder={randomPlaceholder}
    />
  );
};
